import React, { useState } from "react";
import { FaRegCopy } from "react-icons/fa";
import { MdOutlineClose } from "react-icons/md";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { IoMdShare } from "react-icons/io";
import { notifyError } from "../Utils/Helper";


const ReferralCodeModal = ({ closeModal, userId, referralCode }) => {
  const [copiedId, setCopiedId] = useState(null);
  const fullUrl = window.location.href;
  const domain = new URL(fullUrl).origin;
  const referralLink = `${domain}?ref=${referralCode}`;
  const handleCopy = async (id, text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 800);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const generateShareHTML = () => {
    return `
      <div style="font-family: Arial, sans-serif; padding: 16px; color: #333;">
        <img src="https://via.placeholder.com/600x200?text=Welcome+to+Our+Platform" alt="Banner" style="width: 100%; max-width: 600px; border-radius: 8px;" />
        <h2>Discover the Future of Productivity</h2>
        <p>Join our platform to experience seamless project collaboration, real-time updates, and intuitive design—all in one place.</p>
        <img src="https://via.placeholder.com/100" alt="Feature 1" style="margin: 10px;" />
        <img src="https://via.placeholder.com/100" alt="Feature 2" style="margin: 10px;" />
        <img src="https://via.placeholder.com/100" alt="Feature 3" style="margin: 10px;" />
        <p>Click the button below to get started:</p>
        <a href="${referralLink}" target="_blank" style="
          display: inline-block;
          padding: 12px 24px;
          background-color: #4CAF50;
          color: white;
          text-decoration: none;
          border-radius: 4px;
          font-weight: bold;
        ">JOIN NOW</a>
        <p style="margin-top: 20px;">Thank you for spreading the word!</p>
      </div>
    `;
  };

  const handleNativeShare = () => {
    const plainText = `Join me on this platform!\nClick the button below to sign up using my referral:\n${referralLink}`;

    if (navigator.share) {
      navigator
        .share({
          title: "Join me on this platform!",
          text: "Tap the JOIN NOW button below to get started!",
          url: referralLink,
        })
        .catch((error) => {
          console.error("Sharing failed:", error);
          fallbackCopy();
        });
    } else {
      fallbackCopy();
    }
  };

  const fallbackCopy = () => {
    const htmlContent = generateShareHTML();
    const tempElem = document.createElement("textarea");
    tempElem.value = htmlContent;
    document.body.appendChild(tempElem);
    tempElem.select();
    document.execCommand("copy");
    document.body.removeChild(tempElem);
    notifyError("Native share not supported. HTML invitation copied. Paste it into your message/email.");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex items-center justify-center z-50 ">
      <div className="relative bg-white p-6 rounded-lg shadow-md w-[90%] max-w-md">
        <button onClick={closeModal} className="absolute top-3 right-3 text-xl">
          <MdOutlineClose />
        </button>

        <h2 className="text-lg font-semibold mb-4 text-center">Your Referral Info</h2>

        {/* Referral Link */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Referral Link</label>
          <div className="flex">
            <input
              type="text"
              value={referralLink}
              readOnly
              className="flex-1 p-2 border rounded-l"
            />
            <button
              onClick={() => handleCopy("link", referralLink)}
              className="px-3 bg-blue-500 text-white rounded-r"
            >
              {copiedId === "link" ? <IoCheckmarkDoneOutline /> : <FaRegCopy />}
            </button>
          </div>
        </div>

        {/* Referral Code */}
        <div className="mb-6">
          <label className="block text-sm font-medium mb-1">Referral Code</label>
          <div className="flex">
            <input
              type="text"
              value={referralCode}
              readOnly
              className="flex-1 p-2 border rounded-l"
            />
            <button
              onClick={() => handleCopy("code", referralCode)}
              className="px-3 bg-blue-500 text-white rounded-r"
            >
              {copiedId === "code" ? <IoCheckmarkDoneOutline /> : <FaRegCopy />}
            </button>
          </div>
        </div>

        {/* Share Button */}
        <div className="text-center">
          <button
            onClick={handleNativeShare}
            className="flex items-center justify-center gap-2 px-4 py-2 bg-green-500 text-white rounded-md w-full"
          >
            Share Now <IoMdShare />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReferralCodeModal;
